import Skeleton from '@mui/material/Skeleton';
import styles from './SkeletonCourseCard.module.scss';
import { courseCardIds } from '../../../../lib/tests/testIds';

const SkeletonCourseCard = () => {
  return (
    <div className={styles.wrapper} data-testid={courseCardIds.skeleton}>
      <Skeleton variant="rectangular" className={styles.image} />
      <Skeleton className={styles.courseType} />
      <Skeleton className={styles.courseTitle} />
      <Skeleton className={styles.durationAndLink} />
    </div>
  );
};

export default SkeletonCourseCard;
